import React from "react";
import TableUtility from "../../../Common/UtilityCommon/TableUtility";

const GullSaleBillReturnUtility = ({ includeYearCode = true }) => {
    const apiUrl = `${process.env.REACT_APP_API}/getdatagulsalereturn-SaleBill`;
    const columns = [
        { label: "Doc No", key: "doc_no" },
        { label: "Doc Date", key: "doc_date" },
        { label: "Bill From Name", key: "billFromName" },
        { label: "Bill From GST", key: "BillFromGSTNo" },
        { label: "NET Quintal", key: "NETQNTL", format: true },
        { label: "Amount", key: "SubTotal", format: true },
    ];



    const getRowStyle = (row) => {
        if (row.IsDeleted === 0) {
            return { backgroundColor: '#ffcccc' };
        }
        return {};
    };

    return (
        <TableUtility
            title="Gul Sale Return"
            apiUrl={apiUrl}
            columns={columns}
            rowKey="srid"
            addUrl="/Gullsalereturn"
            detailUrl="/Gullsalereturn"
            permissionUrl="/Gullsalereturnutility"
            includeYearCode={includeYearCode}
            getRowStyle={getRowStyle}
        />
    );
};

export default GullSaleBillReturnUtility;
